<template>
  <div v-if="contact">
    <img v-if="contact.PictureUri" :src="contact.PictureUri" alt="" class="picture">
    <h1>{{contact.Name}}</h1>
    <el-collapse v-if="contact" v-model="activeCollapse">
      <el-collapse-item title="Contact Info" name="1">
        <el-row align="middle" type="flex" justify="center" :gutter="20">
          <el-col :sm="{span: 12}" :lg="{span: 8}">
            <view-contact-form
              @edit="isEdit = !isEdit"
              @addNote="onAddNote"
              @deleteNote="onDeleteNote"
              @delete="onDelete"
              @editNote="onEditNote"
              :viewForm="contact"
              v-if=" !isEdit"
            />
            <edit-contact-form
              @cancel="isEdit = !isEdit"
              @save="onSaveContact"
              :form="contact"
              v-if="isEdit"
            />
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import EditContactForm from '@/components/contacts/EditContactForm'
import ViewContactForm from '@/components/contacts/ViewContactForm'
import { mapGetters } from 'vuex'
export default {
  props: ['contactId'],
  data() {
    return {
      activeCollapse: ['1'],
      isEdit: false
    }
  },
  computed: {
    ...mapGetters(['contacts']),
    contact() {
      if (!this.contacts) return null
      return this.contacts.find(c => c.Id === this.contactId)
    }
  },
  methods: {
    onSaveContact(contact) {
      this.$store.dispatch('updateContact', contact)
      this.isEdit = !this.isEdit
    },
    onDelete(contactId) {
      this.$store.dispatch('deleteContact', contactId)
      this.$emit('deselectContact')
    },
    onDeleteNote(note) {
      const contactMinusNote = Object.assign({}, this.contact, {
        Notes: this.contact.Notes.filter(n => n.Id !== note.Id)
      })
      this.$store.dispatch('removeNote', contactMinusNote)
    },
    onAddNote(newNote) {
      const contactPlusNote = Object.assign({}, this.contact, {
        Notes: [{ Note: newNote }, ...this.contact.Notes]
      })
      this.$store.dispatch('addNote', contactPlusNote)
    },
    onEditNote(note) {
      const contactPlusNote = Object.assign({}, this.contact, {
        Notes: this.contact.Notes.map(n => (n.Id === note.Id ? note : n))
      })
      this.$store.dispatch('editNote', contactPlusNote)
    }
  },
  components: { EditContactForm, ViewContactForm }
}
</script>

<style scoped>
.picture {
  border-radius: 50%;
  max-width: 200px;
}
</style>
